<div class="availability-section container-fluid">

  <div class="section-header mb-4">
    <div>
      <h6 class="fw-bold mb-1">Disponibilidad</h6>
      <p class="text-muted mb-0">Gestiona el horario, excepciones, ausencias y bloqueos de cada empleado</p>
    </div>
  </div>

  <div class="alert alert-danger alert-dismissible fade show" *ngIf="errorMessage" role="alert">
    <mat-icon class="align-middle">error</mat-icon>
    <span class="ms-2">{{ errorMessage }}</span>
    <button type="button" class="btn-close" (click)="errorMessage = null"></button>
  </div>

  <div class="alert alert-success alert-dismissible fade show" *ngIf="successMessage" role="alert">
    <mat-icon class="align-middle">check_circle</mat-icon>
    <span class="ms-2">{{ successMessage }}</span>
    <button type="button" class="btn-close" (click)="successMessage = null"></button>
  </div>

  <div class="row">
    
    <div class="col-md-3">
      <div class="staff-panel">
        
        <div class="staff-search mb-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Buscar empleado</mat-label>
            <input matInput [(ngModel)]="staffSearchTerm" (input)="filterStaff()" placeholder="Nombre...">
            <mat-icon matPrefix>search</mat-icon>
          </mat-form-field>
        </div>

        <div class="staff-list">
          <div *ngFor="let staff of filteredStaffList; trackBy: trackByIndex" 
               class="staff-item" 
               [class.active]="selectedEmployeeUid === staff.id"
               (click)="selectStaff(staff.id)">
            <div class="staff-avatar">
              {{ getInitials(staff.display) }}
            </div>
            <div class="staff-info">
              <span class="staff-name">{{ staff.display }}</span>
            </div>
          </div>

          <div *ngIf="filteredStaffList.length === 0" class="staff-empty">
            <mat-icon>person_outline</mat-icon>
            <p>No se encontraron empleados</p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-9">
      
      <div *ngIf="!selectedEmployeeUid" class="no-selection">
        <mat-icon>schedule</mat-icon>
        <h5>Selecciona un empleado</h5>
        <p class="text-muted">Elige un empleado de la lista para gestionar su disponibilidad</p>
      </div>

      <div *ngIf="selectedEmployeeUid" class="availability-config">
        
        <div class="config-header mb-3">
          <div class="d-flex align-items-center">
            <div class="config-avatar">
              {{ getInitials(getSelectedStaffName()) }}
            </div>
            <div>
              <h5 class="mb-0">{{ getSelectedStaffName() }}</h5>
              <span class="text-muted">Configuración de disponibilidad</span>
            </div>
          </div>
        </div>

        <mat-tab-group class="availability-tabs">
          
          <mat-tab label="Horario base">
            <div class="tab-content">

              <div class="tab-header">
                <div>
                  <h6 class="mb-1">Horario semanal recurrente</h6>
                  <p class="text-muted mb-0">Define los tramos horarios para cada día de la semana</p>
                </div>
                <app-button
                  label="Añadir horario"
                  icon="add"
                  variant="primary"
                  (click)="openAvailabilityRuleDialog()">
                </app-button>
              </div>

              <mat-tab-group class="weekday-tabs" animationDuration="0ms">
                <mat-tab *ngFor="let day of weekDays; trackBy: trackByIndex" [label]="day.display">
                  <div class="weekday-tab-content">

                    <ng-container *ngIf="getRulesForDay(day.id).length > 0; else emptyWeekDay">
                      <div class="table-container">
                        <table class="data-table">
                          <thead>
                            <tr>
                              <th>Hora inicio</th>
                              <th>Hora fin</th>
                              <th>Vigencia desde</th>
                              <th>Vigencia hasta</th>
                              <th class="text-center">Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let rule of getRulesForDay(day.id); trackBy: trackByIndex">
                              <td>{{ rule.startTime }}</td>
                              <td>{{ rule.endTime }}</td>
                              <td>{{ rule.effectiveFrom || '-' }}</td>
                              <td>{{ rule.effectiveTo || '-' }}</td>
                              <td class="text-center">
                                <button mat-icon-button matTooltip="Editar" (click)="editRule(rule)">
                                  <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-icon-button matTooltip="Eliminar" color="warn" (click)="deleteRule(rule)">
                                  <mat-icon>delete</mat-icon>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </ng-container>

                    <ng-template #emptyWeekDay>
                      <div class="empty-state empty-state-weekday">
                        <mat-icon>schedule</mat-icon>
                        <h6>Sin horario para {{ day.display.toLowerCase() }}</h6>
                        <p class="text-muted mb-3">Añade un tramo horario para este día</p>
                        <app-button
                          label="Añadir horario"
                          icon="add"
                          variant="primary"
                          (click)="openAvailabilityRuleDialog()">
                        </app-button>
                      </div>
                    </ng-template>

                  </div>
                </mat-tab>
              </mat-tab-group>

            </div>
          </mat-tab>

          <mat-tab label="Excepciones">
            <div class="tab-content">
              
              <div class="tab-header">
                <div>
                  <h6 class="mb-1">Excepciones en fechas concretas</h6>
                  <p class="text-muted mb-0">Define días cerrados u horarios especiales</p>
                </div>
                <app-button 
                  label="Añadir excepción" 
                  icon="add" 
                  variant="primary" 
                  (click)="openExceptionDialog()">
                </app-button>
              </div>

              <div *ngIf="exceptions.length > 0; else emptyExceptions" class="table-container">
                <table class="data-table">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Tipo</th>
                      <th>Hora inicio</th>
                      <th>Hora fin</th>
                      <th class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let exception of exceptions; let i = index; trackBy: trackByIndex">
                      <td><strong>{{ exception.date | date:'dd/MM/yyyy' }}</strong></td>
                      <td>
                        <span class="badge" [class.badge-closed]="exception.isClosed" [class.badge-special]="!exception.isClosed">
                          {{ exception.isClosed ? 'Cerrado' : 'Horario especial' }}
                        </span>
                      </td>
                      <td>{{ exception.isClosed ? '-' : exception.startTime }}</td>
                      <td>{{ exception.isClosed ? '-' : exception.endTime }}</td>
                      <td class="text-center">
                        <button mat-icon-button matTooltip="Editar" (click)="editException(i)">
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button matTooltip="Eliminar" color="warn" (click)="deleteException(i)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <ng-template #emptyExceptions>
                <div class="empty-state">
                  <mat-icon>event_busy</mat-icon>
                  <h5>No hay excepciones configuradas</h5>
                  <p class="text-muted">Añade días festivos, cierres o cambios de horario puntuales</p>
                  <app-button 
                    label="Añadir primera excepción" 
                    icon="add" 
                    variant="primary" 
                    (click)="openExceptionDialog()">
                  </app-button>
                </div>
              </ng-template>
            </div>
          </mat-tab>

          <mat-tab label="Ausencias">
            <div class="tab-content">
              
              <div class="tab-header">
                <div>
                  <h6 class="mb-1">Ausencias del empleado</h6>
                  <p class="text-muted mb-0">Vacaciones, bajas médicas, permisos, etc.</p>
                </div>
                <app-button 
                  label="Añadir ausencia" 
                  icon="add" 
                  variant="primary" 
                  (click)="openTimeOffDialog()">
                </app-button>
              </div>

              <div *ngIf="timeOffs.length > 0; else emptyTimeOffs" class="table-container">
                <table class="data-table">
                  <thead>
                    <tr>
                      <th>Inicio</th>
                      <th>Fin</th>
                      <th>Motivo</th>
                      <th>Duración</th>
                      <th class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let timeOff of timeOffs; let i = index; trackBy: trackByIndex">
                      <td>{{ timeOff.startAt | date:'dd/MM/yyyy HH:mm' }}</td>
                      <td>{{ timeOff.endAt | date:'dd/MM/yyyy HH:mm' }}</td>
                      <td>{{ timeOff.reason || '-' }}</td>
                      <td>{{ calculateDuration(timeOff.startAt, timeOff.endAt) }}</td>
                      <td class="text-center">
                        <button mat-icon-button matTooltip="Editar" (click)="editTimeOff(i)">
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button matTooltip="Eliminar" color="warn" (click)="deleteTimeOff(i)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <ng-template #emptyTimeOffs>
                <div class="empty-state">
                  <mat-icon>beach_access</mat-icon>
                  <h5>No hay ausencias registradas</h5>
                  <p class="text-muted">Registra vacaciones, bajas o permisos del empleado</p>
                  <app-button 
                    label="Añadir primera ausencia" 
                    icon="add" 
                    variant="primary" 
                    (click)="openTimeOffDialog()">
                  </app-button>
                </div>
              </ng-template>
            </div>
          </mat-tab>

          <mat-tab label="Bloqueos">
            <div class="tab-content">
              
              <div class="tab-header">
                <div>
                  <h6 class="mb-1">Bloqueos manuales de agenda</h6>
                  <p class="text-muted mb-0">Mantenimientos, reuniones internas, bloqueos temporales</p>
                </div>
                <app-button 
                  label="Añadir bloqueo" 
                  icon="add" 
                  variant="primary" 
                  (click)="openBlockDialog()">
                </app-button>
              </div>

              <div *ngIf="blocks.length > 0; else emptyBlocks" class="table-container">
                <table class="data-table">
                  <thead>
                    <tr>
                      <th>Inicio</th>
                      <th>Fin</th>
                      <th>Motivo</th>
                      <th class="text-center">Activo</th>
                      <th class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let block of blocks; let i = index; trackBy: trackByIndex" [class.inactive-row]="!block.isActive">
                      <td>{{ block.startAt | date:'dd/MM/yyyy HH:mm' }}</td>
                      <td>{{ block.endAt | date:'dd/MM/yyyy HH:mm' }}</td>
                      <td>{{ block.reason || '-' }}</td>
                      <td class="text-center">
                        <mat-checkbox [checked]="block.isActive" (change)="toggleBlockActive(i)"></mat-checkbox>
                      </td>
                      <td class="text-center">
                        <button mat-icon-button matTooltip="Editar" (click)="editBlock(i)">
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button matTooltip="Eliminar" color="warn" (click)="deleteBlock(i)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <ng-template #emptyBlocks>
                <div class="empty-state">
                  <mat-icon>block</mat-icon>
                  <h5>No hay bloqueos configurados</h5>
                  <p class="text-muted">Añade bloqueos manuales de agenda para mantenimientos o reuniones</p>
                  <app-button 
                    label="Añadir primer bloqueo" 
                    icon="add" 
                    variant="primary" 
                    (click)="openBlockDialog()">
                  </app-button>
                </div>
              </ng-template>
            </div>
          </mat-tab>

        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
